<template>
  <v-list-item>
    <v-list-item-content>
      <v-list-item-title>
        <Attribute
          :item="formatDateRange()"
          :translate="attribute.translate"
        />
      </v-list-item-title>
      <v-list-item-subtitle>{{attribute[`label_${$i18n.locale}`]}}</v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
</template>
<script>
import Attribute from '@/components/dashboard/Attribute';
export default {
  components: {
    Attribute
  },
  props: {
    attribute: {
      required: true,
      type: Object
    }
  },
  methods: {
    formatDateRange() {
      if (!this.attribute.value) {
        return null;
      }
      let options = { year: 'numeric', month: 'long' };
      // const from = new Date(this.attribute.value.from).toLocaleDateString(
      //   this.$i18n.locale === 'pl' ? 'pl-PL' : 'en-EN',
      //   options
      // );
      const from = this.attribute.value.from;
      // const to = new Date(this.attribute.value.to).toLocaleDateString(
      //   this.$i18n.locale === 'pl' ? 'pl-PL' : 'en-EN',
      //   options
      // );
      const to = this.attribute.value.to;
      return { from: from, to: to };
    }
  }
};
</script>